export default __webpack_public_path__ + "assets/864c2bdfdea09ee848334af61b5e14d0.svg";